import React from 'react'
import ExploreProducts from './ExploreProducts'
import ExploreProductsAccordianMobile from './ExploreProductsAccordianMobile'
import $ from 'jquery';

class Banner extends React.Component{
    constructor(props){
        super(props);
        this.state= {
            width: window.innerWidth,
            downarrowIcon: true,
            primaryBtnFocused: false,
            secondaryBtnFocused: false,
            primaryBtnHovered: false,
            secondaryBtnHovered: false
        }
    }
    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };
    toggleArrowHandler = () => {
        this.setState({
            downarrowIcon: !this.state.downarrowIcon
        })
    }
    toggleFocusPrimaryButton = () => {
        this.setState(prevState => ({
            primaryBtnFocused: !prevState.primaryBtnFocused
        }))
    }
    toggleFocusSecondaryButton = () => {
        this.setState(prevState => ({
            secondaryBtnFocused: !prevState.secondaryBtnFocused
        }))
    }
    toggleHoverPrimaryButton = () => {
        this.setState(prevState => ({
            primaryBtnHovered: !prevState.primaryBtnHovered
        }))
    }
    toggleHoverSecondaryButton = () => {
        this.setState(prevState => ({
            secondaryBtnHovered: !prevState.secondaryBtnHovered
        }))
    }
    componentDidMount(){
        this.props.bannerData && this.props.bannerData.forEach(bannerComponent => {
            this.setState({
                [bannerComponent.acf_fc_layout]: bannerComponent.content
            },()=>{
                this.state.background_image.forEach(image => {
                    this.setState({
                        [image.acf_fc_layout]: image.content
                    })
                });
                this.state.button_block.forEach(button => {
                    this.setState({
                        [button.button_type]: button
                    })
                })
            })
        });
        window.addEventListener('resize', this.handleWindowSizeChange);
        if (document.readyState === "complete") {
            if(window.location.hash=="#exploreProducts"){
                setTimeout(() => { 
                    $("button.explore-btn").trigger("click");$("body,html").animate({scrollTop: $("#exploreProducts").offset().top+50},800);
                }, 2000);
            }
            $("div").delegate(".exploreLink", "click", function(e){
                e.preventDefault();e.stopImmediatePropagation();
                var aexpanded=$("button.explore-btn").attr("aria-expanded");
                if(aexpanded=="true"){}else{$("button.explore-btn").trigger("click");}
                $("body,html").animate({scrollTop: $("#exploreProducts").offset().top+50},800);
            });
        } else {
            window.addEventListener('load', this.handleLoad);
        }
        
    }
    componentWillUnmount(){
        window.removeEventListener('resize', this.handleWindowSizeChange);
        window.removeEventListener('load', this.handleLoad);
    }
    handleLoad() {
        if(window.location.hash=="#exploreProducts"){
            $("button.explore-btn").trigger("click");$("body,html").animate({scrollTop: $("#exploreProducts").offset().top+50},800);
        }
        $("div").delegate(".exploreLink", "click", function(e){
            e.preventDefault();e.stopImmediatePropagation();
            var aexpanded=$("button.explore-btn").attr("aria-expanded");
            if(aexpanded=="true"){}else{$("button.explore-btn").trigger("click");}
            $("body,html").animate({scrollTop: $("#exploreProducts").offset().top+50},800);
            
        });
    }
    
    render(){
        let collapseContentCopy = null;
        if(this.state.Primary){
            collapseContentCopy = JSON.parse(JSON.stringify(this.state.Primary.collapse));
        }
        const { width } = this.state;
        let bannerImage = null;
        let bannerContainer = null;
        if(this.state.banner_image){
            bannerImage = {
                "background": `url(${this.state.banner_image}) no-repeat`
            }
        }
        
        if(width <= 576 && this.state.mobile){
            bannerContainer = {
                "background": `url(${this.state.mobile}) no-repeat`
            }
        }
        if(width <= 991 && width > 576 && this.state.tablet){
            bannerContainer = {
                "background": `url(${this.state.tablet}) no-repeat`
            }
        }
        if(width > 991 && this.state.desktop){
            bannerContainer = {
                "background": `url(${this.state.desktop}) no-repeat`
            }
        }
        return(
            <section className={`banner-section ${!this.props.blurBackground ? "background-fade" : "" }`}
            style={bannerContainer}>
                <div className="container banner-container">
                    <div className="row banner-position">
                        <div className='col-xs-12 col-sm-10 col-md-9 col-lg-8 col-xl-7'>
                            <div className='row' dangerouslySetInnerHTML={{ __html: this.state.hero_text_block}}/>
                                
                            <div className='row' dangerouslySetInnerHTML={{ __html: this.state.text_block}}/>
                                
                            <div className='row banner-btn'>
                                <div className='col-xs-12 col-sm-6 col-md-6 col-lg-5 col-xl-5 order-sm-12'>
                                    {this.state.Secondary &&
                                    <a href={this.state.Secondary.button_link}>
                                        <button className={`login-btn
                                        ${this.state.secondaryBtnFocused? "blue-btn-focused":""}
                                        ${this.state.secondaryBtnHovered? "secondary-btn-hovered":""}`}
                                        type="button"
                                        onFocus={this.toggleFocusSecondaryButton}
                                        onBlur={this.toggleFocusSecondaryButton}
                                        onMouseEnter={this.toggleHoverSecondaryButton}
                                        onMouseLeave={this.toggleHoverSecondaryButton}>
                                            {this.state.Secondary.button_text}
                                        </button>
                                    </a>
                                    }
                                </div>
                                <div className='col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 order-sm-1 explore-btn-container'>
                                    {this.state.Primary &&
                                    <button className={`explore-btn
                                        ${this.state.primaryBtnFocused? "blue-btn-focused":""}
                                        ${this.state.primaryBtnHovered?  "primary-btn-hovered":""}`}
                                        type="button" data-toggle="collapse" 
                                        data-target="#exploreProducts" 
                                        aria-expanded="false"
                                        aria-controls="exploreProducts"
                                        onFocus={this.toggleFocusPrimaryButton}
                                        onBlur={this.toggleFocusPrimaryButton}
                                        onMouseEnter={this.toggleHoverPrimaryButton}
                                        onMouseLeave={this.toggleHoverPrimaryButton}
                                        onClick={this.toggleArrowHandler}>
                                            {this.state.Primary.button_text}
                                            <span className={this.state.downarrowIcon?'fa fa-chevron-down':
                                            'fa fa-chevron-up'}></span>
                                    </button>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className='col-xs-0 col-sm-2 col-md-3 col-lg-3 col-xl-3 bannerbulb-container'>
                            <div className="bannerbulb" style={bannerImage}></div>
                        </div>
                    </div> 
                </div>
                    {this.state.Primary && this.state.Primary.is_collapse?
                    <React.Fragment>
                    <ExploreProductsAccordianMobile
                        exploreProductsData={collapseContentCopy}
                        toggleArrowHandler={this.toggleArrowHandler}/>
                    <ExploreProducts
                        exploreProductsData={this.state.Primary.collapse}
                        toggleArrowHandler={this.toggleArrowHandler}/>
                    </React.Fragment>:null
                } 
            </section>
        )
    }
}
export default Banner